import { useEffect, useState } from 'react';
import { useIntl } from "react-intl";

import { StatusService } from '../../services/StatusService';

import Toast from "../../helpers/Toast";

import { FormattedMessage } from 'react-intl';
import ButtonComponent from '../../components/ButtonComponent';
import useValidationSchema, { FieldConfig } from "../../components/Validations";
import { RolePossibleStatusPermissionDTO } from "../../models/Status/RolePossibleStatusPermissionDTO";
import { RoleDTO } from '../../models/User/RoleDTO';
import { SearchRoleDTO } from '../../models/User/SearchRoleDTO';
import { SelectItemsProps } from '../SearchSelectComponent';
import SelectComponent from '../SelectComponent';
import { Row, Col } from 'reactstrap';
import { GetPossibleStatusByBaseStatus } from '../../models/Status/GetPossibleStatusByBaseStatusDTO';

type NextPossibleStatusProps = {
    BaseStatus: number;
    nextStatus: string;
    baseStatusName: string;
    onSuccess: () => void;
    onCancel: () => void;
}

function CreateNextStatusPermission(props: NextPossibleStatusProps){
    const statusService = new StatusService();
    const intl = useIntl();
    const [loading, setLoading] = useState(false);
    const [roles, setRoles] = useState<SelectItemsProps[]>([]);
    const [nameRole, setNameRole] = useState<RoleDTO>({} as RoleDTO);

    const fields: FieldConfig[] = [
        ["roleId", "string", "Screens.Status.Create.Permission.Role"],
    ]

    const schemaClientValidation = useValidationSchema(fields);

    const GetAllRoles = async () => {
        const response = await statusService.GetAllRoles();

        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
            return [];
        }

        const list: SelectItemsProps[] = [];

        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.id.toString(),
                label: element.name,
            }
            list.push(item);
        });

        setRoles(list);
    }

    useEffect(() => {
        GetAllRoles();
    }, [props.BaseStatus]);

    const GetStatusRole = async ( currentPage: number, pageSize: number ) => {
        const data: GetPossibleStatusByBaseStatus = {
          id : String(props.BaseStatus), 
          currentPage : currentPage,
          pageSize : pageSize,
        }

        const role = await statusService.GetPermissionToNavigateStatus(data);

        if (role.success === false || role.items == null) {
          Toast.Show("error", "Não foi possível encontrar os perfis permitidos.");
          return;
        }

        if (role.items.length === 0) {
            setRoles([]);
        } else {
        const mappedRoles: SelectItemsProps[] = role.items.map((item) => ({
            value: item.roleId,
            label: item.roleName ?? ""
        }));
        setRoles(mappedRoles);
        }

    }

    const CreateNextStatusPermission = async () => {
        setLoading(true);

        const searchRole: SearchRoleDTO = {
            name: nameRole.name,
        }

        const data: RolePossibleStatusPermissionDTO = {
            roleId: nameRole?.id ?? null,
            nextPossibleStatusId: props.BaseStatus ?? null,
            roleName: nameRole?.name ?? null,
        };

        var role = await statusService.GetRoleByName(searchRole);

        if (role.obj == null) {
            setLoading(false);
            const { error } = schemaClientValidation.validate(data);
            if (error) {
                Toast.Show("error", error.details.map(detail => detail.message).join(', '));
                setLoading(false);
                return;
            }
            return;
        }

        data.roleId = (role.obj.id).toString();

        const result = await statusService.CreatePossibleStatusPermission(data);

        if (result.success === false) {
            Toast.Show("error", "Permissão para esse perfil já existe, não a vamos duplicar.");
            setLoading(false);
            return;
          }

          Toast.Show("success", "Permissão criada com sucesso.");
          setLoading(false);
          props.onSuccess();
    }

    return(
        <>
            <Col>
                <SelectComponent
                xl={12}
                lg={12}
                md={12}
                sm={12}
                xs={12}
                style={{ width: "100%", height: "43px", marginBottom: "25px"}}
                label={intl.formatMessage({ id: "Screens.Status.Search.Role" })}
                selectedItemValue={nameRole.id ?? ""}                
                items={roles}
                onChange={(selectedId: string) => {
                const selectedRole = roles.find(r => r.value === selectedId);
                setNameRole({
                    id: selectedId,
                    name: selectedRole ? selectedRole.label : ""
                    });
                }}
                />
            </Col>
            <div style={{ display: "flex", justifyContent: "flex-end", padding: "16px" }}>
                <ButtonComponent
                    text={intl.formatMessage({ id: "Common.Buttons.Cancel"})}
                    onClick={props.onCancel}
                    style={{ marginRight: "8px" }}
                />
                <ButtonComponent
                    text={intl.formatMessage({ id: "Screens.Status.Create.Permission" })}
                    onClick={CreateNextStatusPermission}
                />
            </div>

        </>
    );

}

export default CreateNextStatusPermission;